<template>
  <RoleGate minLevel="supervisor" :showWhenDenied="true">
    <div class="settings-form">
      <div class="actions-header">
         <p class="helper-text"><i class="bi bi-info-circle-fill"></i> O sistema exige pelo menos 1 usuário Manager cadastrado.</p>
         <AddPrestador label="Adicionar Usuário" @click="isModalVisible = true" />
      </div>

      <!-- Users Grid -->
      <div class="users-list">
        <div class="user-card" v-for="(item, index) in localDataUsers" :key="item.username">
          
          <div class="user-card-header">
             <div class="user-avatar">
               <i class="bi bi-person-fill"></i>
             </div>
             <div class="user-title">
               <h4>{{ item.name }}</h4>
               <span>{{ item.username }}</span>
             </div>
          </div>

          <div class="user-card-body">
             <div class="form-group row-flex">
                <label>Perfil</label>
                <div class="select-wrapper">
                  <select v-if="item.roles" v-model="item.roles[0]" class="form-select">
                      <option disabled value="">Selecione</option>
                      <option v-for="role in localDataRoles" :key="role" :value="role">{{ role }}</option>
                  </select>
                  <i class="bi bi-chevron-down select-icon"></i>
                </div>
             </div>

             <div class="form-group row-flex align-right">
                <label>Ativo</label>
                <label class="modern-switch">
                  <input type="checkbox" v-model="item.status" />
                  <span class="slider"></span>
                </label>
             </div>
          </div>

        </div>
      </div>

      <div class="form-actions mt-4">
          <BotaoSalvarComponent @click="editUser" />
      </div>
    </div>
  </RoleGate>

  <Modal :isVisible="isModalVisible" @close="isModalVisible = false">
      <div class="modal-header-v2">
         <h3>Novo Usuário</h3>
         <button class="close-btn" @click="isModalVisible = false"><i class="bi bi-x-lg"></i></button>
      </div>

      <div class="modal-body-v2 settings-form">
          <div class="form-group">
            <label>Nome Completo</label>
            <div class="input-wrapper">
              <i class="bi bi-person-lines-fill icon"></i>
              <input type="text" class="form-control" v-model="name" placeholder="Digite o nome" required />
            </div>
          </div>

          <div class="form-group">
            <label>E-mail (Username)</label>
            <div class="input-wrapper">
              <i class="bi bi-envelope-at-fill icon"></i>
              <input type="email" class="form-control" v-model="username" placeholder="email@exemplo.com" required />
            </div>
          </div>

          <div class="form-group">
            <label>Nível de Acesso (Perfil)</label>
            <div class="select-wrapper default-border">
              <select v-model="role" class="form-select" required>
                  <option value="" disabled selected>Selecione o nível</option>
                  <option v-for="(item, index) in localDataRoles" :key="index" :value="item">{{ item }}</option>
              </select>
              <i class="bi bi-chevron-down select-icon"></i>
            </div>
          </div>
      </div>

      <div class="modal-footer-v2">
          <button class="btn-cancel" @click="isModalVisible = false">Cancelar</button>
          <BotaoSalvarComponent @click="saveNewUser" />
      </div>
  </Modal>
</template>

<script setup>
import axios from '@/axios.js';
import BotaoSalvarComponent from './ui/BotaoSalvar.vue';
import Modal from '@/components/Modal.vue';
import { showToast } from '@/eventBus.js';
import { onMounted, ref } from 'vue';
import RoleGate from './RoleGate.vue';
import AddPrestador from '../components/ui/BtnAdicionar.vue';

const localDataUsers = ref([]);
const localDataRoles = ref([]);
const isModalVisible = ref(false);
const role = ref('');
const username = ref('');
const name = ref('');

const props = defineProps({
    companyData: { type: Object, required: true },
});

onMounted(async () => {
    const companyId = localStorage.getItem("idCompany");

    axios.get(`/auth/users/${companyId}`)
        .then(response => {
            localDataUsers.value = response.data.data.users;
            localDataRoles.value = response.data.data.roles;
        })
        .catch(error => {
            showToast(error?.response?.data?.message || "Erro ao buscar os dados do servidor.");
        });
});

function editUser() {
   const companyId = localStorage.getItem("idCompany");
   
    axios.put(`/auth/users/edit/${companyId}`, localDataUsers.value)
        .then(response => {
            localDataUsers.value = response.data.data.users;
            showToast(response.data.message);
        }).catch(error => {
            showToast(error?.response?.data?.message || "Erro ao salvar os dados dos usuários.");
        });
};

function saveNewUser() {
    const companyId = localStorage.getItem("idCompany");
    const insertUser = {
        username: username.value,
        name: name.value,
        roles: [role.value]
    };

    axios.post(`/auth/register/${companyId}`, insertUser)
        .then(response => {
            showToast(response.data.message || "Usuário adicionado com sucesso!!!");
            isModalVisible.value = false;
        }).catch(error => {
            showToast(error?.response?.data?.message || "Erro ao adicionar o usuário.");
        });
};
</script>

<style scoped>
/* V2 Generic Form Setup */
.settings-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.actions-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.helper-text {
  margin: 0;
  font-size: 0.9rem;
  color: #64748B;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.helper-text i {
  color: #3B82F6;
}

/* User Cards System */
.users-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 1.5rem;
}

.user-card {
  background: #FFFFFF;
  border: 1px solid #E2E8F0;
  border-radius: 16px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  box-shadow: 0 2px 4px rgba(0,0,0,0.02);
  transition: all 0.2s;
}

.user-card:hover {
  border-color: #CBD5E1;
  box-shadow: 0 8px 12px rgba(0,0,0,0.04);
}

.user-card-header {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.user-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #F1F5F9;
  color: #64748B;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}

.user-title h4 {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #0F172A;
}

.user-title span {
  font-size: 0.85rem;
  color: #94A3B8;
  font-weight: 500;
}

.user-card-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px dashed #E2E8F0;
}

/* Forms & Selectors */
.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.form-group.row-flex {
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.form-group label {
  font-weight: 600;
  color: #475569;
  font-size: 0.85rem;
}

/* Base Wrapper Input */
.input-wrapper {
  display: flex;
  align-items: center;
  background-color: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  padding: 0.5rem 1rem;
  transition: all 0.2s ease;
}

.input-wrapper:focus-within {
  border-color: #DF523A;
  background-color: #FFF;
  box-shadow: 0 0 0 3px rgba(223, 82, 58, 0.1);
}

.input-wrapper .icon {
  font-size: 1.15rem;
  color: #94A3B8;
  margin-right: 0.75rem;
}

.form-control {
  flex: 1;
  background: transparent;
  border: none;
  font-family: inherit;
  font-size: 0.95rem;
  color: #1E293B;
  outline: none;
}

.form-control::placeholder {
  color: #CBD5E1;
}

/* Select wrapper */
.select-wrapper {
  position: relative;
  width: 130px;
}
.select-wrapper.default-border {
  width: 100%;
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  padding: 0.5rem 1rem;
}
.select-wrapper.default-border:focus-within {
  border-color: #DF523A;
  background-color: #FFF;
}

.form-select {
  width: 100%;
  appearance: none;
  background: transparent;
  border: none;
  font-weight: 600;
  color: #334155;
  font-size: 0.9rem;
  padding-right: 2rem;
  outline: none;
  cursor: pointer;
}

.select-icon {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  color: #94A3B8;
  pointer-events: none;
}

.select-wrapper.default-border .select-icon {
  right: 1rem;
}

/* Modern Switch Toggle */
.modern-switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
}

.modern-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #CBD5E1;
  transition: .3s;
  border-radius: 24px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .3s;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

input:checked + .slider {
  background-color: #10B981; /* Standard Success Green */
}

input:checked + .slider:before {
  transform: translateX(20px);
}

.form-actions {
  display: flex;
  justify-content: flex-end;
}

/* V2 Modal Overlay Customizer */
.modal-header-v2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1rem;
  border-bottom: 1px solid #E2E8F0;
  margin-bottom: 1.5rem;
}

.modal-header-v2 h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 800;
  color: #0F172A;
}

.close-btn {
  background: transparent;
  border: none;
  font-size: 1.25rem;
  color: #94A3B8;
  cursor: pointer;
  transition: color 0.2s;
}

.close-btn:hover {
  color: #EF4444;
}

.modal-footer-v2 {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #E2E8F0;
}

.btn-cancel {
  background: transparent;
  border: none;
  font-weight: 600;
  color: #64748B;
  cursor: pointer;
  padding: 0.5rem 1rem;
  transition: color 0.2s;
}

.btn-cancel:hover {
  color: #0F172A;
}
</style>